export default "__VITE_ASSET__CIpxGQb8__"